export enum ApiMethod {
    POST = 'post',
    GET = 'get',
    PUT = 'put',
    PATCH = 'patch', 
    DELETE = 'delete',
}